import React, { useState, useRef } from "react";

const sections = [
  {
    title: "Section 3 : BROAD BASED BLACK ECONOMIC EMPOWERMENT",
    questions: [
      {
        title: (
          <>
            <span className="font-bold">
              BBBEE ratings certificate, if you are an existing business with a
              turnover of more than R5 million.
            </span>
            If you do not have a rating, please do a self-assessment at{" "}
            http://bee.thedti.gov.za. Remember that your BBBEE rating is not
            necessarily dependent on ownership alone.
          </>
        ),
        uploads: [
          "Attach copy of document here (pdf , .Jpeg)",
          "Attach copy of document here (pdf , .Jpeg)",
        ],
      },

    ],
  },
  {
    title: "Section 4 :ORGANOGRAM",
    questions: [
  
      {
        title: (
          <>
            <span className="font-bold">
            Group structure (if there is more than one company).
            Hierarchy of staff .
            </span>
          </>
        ),
        uploads: [
          "Attach copy of document here (pdf , .Jpeg)",
          "Attach copy of document here (pdf , .Jpeg)",
        ],
      },
    ],
  },
  {
    title: "Section 5 : LAND AND BUILDINGS",
    questions: [
  
      {
        title: <>
    <span className="font-bold">
    Lease agreement or Offer to Purchase/Purchase 
    and Sale agreement. 
    </span>
The IDC does not generally fund the acquisition of land 
or construction of buildings. If you have very specialised 
building requirements, please contact us for more information 
regarding the information required for construction projects.</>,
uploads: [
          "Attach copy of document here (pdf , .Jpeg)",
          "Attach copy of document here (pdf , .Jpeg)",
        ],
        
      },
    ],
  },
  {
    title: "Section 5 :  COMPLIANCE",
    questions: [
   
      {
        title: <>
     <span className="font-bold">   Proof that all necessary regulatory approvals have been 
     obtained or at least applied for</span> (i.e.  Environmental Impact 
Assessments (EIA), rezoning of property if required, etc.). </>,
uploads: [
          "Attach copy of document here (pdf , .Jpeg)",
          "Attach copy of document here (pdf , .Jpeg)",
        ],
      },

    ],
  },
  {
    title: "Section 5 :CAPITAL EXPENDITURE",
    questions: [
    
   
      {
        title: <>
<span className="font-bold">          Quotations from suppliers for all  xed assets to be purchased 
(not older than 3 months).</span>
 Ensure that the  fixed assets to be purchased are sufficient 
to meet production forecasts from a capacity point of view.
Be sure to budget adequately for other “soft assets” such as 
office furniture, photocopy and fax machine.
        </>,
       uploads: [
          "Attach copy of document here (pdf , .Jpeg)",
          "Attach copy of document here (pdf , .Jpeg)",
        ],
      },
    ],
  },
  {
    title: "Section 5 : PRODUCTION",
    questions: [
   
      {
        title: <>
<span className="font-bold">Production process description and process  ow diagram.</span>
A copy of the factory layout.
A detailed bill of materials, together with recent quotations for all raw material input costs.
        </>,
uploads: [
          "Attach copy of document here (pdf , .Jpeg)",
          "Attach copy of document here (pdf , .Jpeg)",
        ],
      },
    ],
  },
  {
    title: "Section 5 :  STAFFING",
    questions: [
    
      {
        title: <>
        <span className="font-bold">Cost-to-company breakdown of all salaried, waged, part-time and contract employees, historical and going forward.</span>
        Number of staff  and their cost-to-company by 
       occupational level.
        Please include details of all staff, from part-time to 
       director level.
       </>,
uploads: [
          "Attach copy of document here (pdf , .Jpeg)",
          "Attach copy of document here (pdf , .Jpeg)",
        ],
      },
    ],
  },
  {
    title: "Section 5 : MARKETING",
    questions: [
      {
        title: <>
        <span className="font-bold">Sales forecasts.</span> <br/>
        Projected turnover levels need to be based on 
        secured contracts, letters of intent and/or detailed 
        market research. 
        Copies of all contracts with customers (these may still 
        be in draft form), letters of intent from potential customers 
        and market research to be provided..</>,
uploads: [
          "Attach copy of document here (pdf , .Jpeg)",
          "Attach copy of document here (pdf , .Jpeg)",
        ],
      },
    ],
  },
  
];

const UploadBox = ({ text, image, onImageChange }) => {
  const inputRef = useRef();

  const handleClick = () => {
    inputRef.current.click();
  };

  return (
    <div className="w-[80px] md:w-[182px] h-full mx-1 md:mx-6 bg-[#E7EBEB] rounded-[5px] p-2 md:p-4 text-[6px] md:text-[18px] leading-snug relative flex items-center justify-center overflow-hidden">
      <input
        type="file"
        accept="image/*"
        ref={inputRef}
        onChange={onImageChange}
        style={{ display: "none" }}
      />
      <div
        onClick={handleClick}
        className="absolute top-1 right-2 text-[5px] md:text-[24px] cursor-pointer z-10"
      >
        <img
          src="https://res.cloudinary.com/dzngpgki4/image/upload/v1746028067/Add_square_ztbsgd.png"
          alt="Add"
          className="w-[10px] md:w-[34px]"
        />
      </div>
      {image ? (
        <img
          src={URL.createObjectURL(image)}
          alt="Uploaded"
          className="w-full h-full object-cover rounded-[5px]"
        />
      ) : (
        <p className="absolute bottom-10 md:bottom-12 p-4">{text}</p>
      )}
    </div>
  );
};

export default function Section3() {
  const [uploads, setUploads] = useState({});

  const handleUploadChange = (key, uploadIndex, file) => {
    setUploads((prev) => ({
      ...prev,
      [key]: {
        ...(prev[key] || {}),
        [uploadIndex]: file,
      },
    }));
  };

  return (
    <div className="space-y-4">
      {sections.map((section, secIdx) => (
        <div key={secIdx}>
          <div className="flex justify-end md:mt-2 mt-2">
            <button
              className="flex items-center md:gap-2 gap-2 hover:bg-[#0f1f1a] text-black hover:text-white md:py-3 py-1 rounded-md text-[6px] md:text-lg font-normal italic transition"
            >
              Save
              <img
                src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745670022/Arhive_load_duotone_line_c6pcpp.png"
                alt="Save Icon"
                className="md:w-11 md:h-11 h-3 w-3"
              />
            </button>
          </div>
          <h2 className="text-[8px] md:text-[24px] font-bold mb-2 text-[#03897B]">
            <span className="text-[#979797]">
              {section.title.split(":")[0]} :
            </span>{" "}
            {section.title.split(":")[1]}
          </h2>

          {section.questions.map((q, i) => (
            <div
              key={i}
              className="flex space-x-2 h-[100px] md:h-[233px] md:min-w-[700px]"
            >
              <div className="w-[200px] md:w-[780px] bg-[#E7EBEB] rounded-[5px] p-3 md:p-4 text-[6px] md:text-[24px] inline leading-[1.2]">
                {q.title}
              </div>

              <div className="flex space-x-1 md:-space-x-1">
                {q.uploads?.map((text, idx) => (
                  <UploadBox
                    key={idx}
                    text={text}
                    image={uploads[`${secIdx}-${i}`]?.[idx]}
                    onImageChange={(e) => {
                      const file = e.target.files[0];
                      if (file) {
                        handleUploadChange(`${secIdx}-${i}`, idx, file);
                      }
                    }}
                  />
                ))}
              </div>
            </div>
          ))}
        </div>
      ))}
    </div>
  );
}
